import { combineReducers } from "redux";

import { isAuthenticated, token, client, user } from "auth/reducers";
import message from "reducers/message";
import error from "reducers/error";
import sidebar from "reducers/sidebar";

import editor from "editor/reducers";
import dashboard from "dashboard/reducers";
import deepDiveEditor from "deepDiveEditor/reducers";
import settings from "settings/reducers";
import curation from "curation/reducers";

export default combineReducers({
  client,
  user,
  isAuthenticated,
  message,
  error,
  token,
  dashboard,
  editor,
  deepDiveEditor,
  settings,
  curation,
  isSidebarExpanded: sidebar,
});
